//引入axios实例
import axios from "axios";
//引入一个loading组件
import { Message } from 'element-ui'
// loading初始值为0
//配置基地址
let baseURL = window.config.apiBaseUrl
//请求拦截器  我们在发起请求之前可以在这个实例里面做操作
axios.interceptors.request.use(
    function (config) {
        let username = localStorage.getItem('username')
        if(username) {
            // 添加到请求参数中
            config.params = {
                ...config.params,
                username
            }
        }
        const token = localStorage.getItem("token");
        // 如果token存在 将token放在请求头中
        if (token) {
            //在请求头中携带Token
            config.headers.Authorization = `Bearer ${token}`
        }
        return config;
    },

    function (error) {
        // 对请求错误做些什么
        return Promise.reject(error);
    }
);

// 添加响应拦截器
axios.interceptors.response.use(
    function (response) {

        // 对响应数据做点什么
        // index.close(); //关闭加载框
        return response;

    },
    function (error) {
        // 对响应错误做点什么
        return Promise.reject(error);
    }
);


export default {
    http(methods, url, data) {
        return new Promise((resolve, reject) => {
            return axios({
                method: methods,//请求类型
                baseURL: baseURL,//接口基础地址
                timeout: 3000,//超时时间
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    'source-client': 'miniapp',
                },//请求头类型
                url,//接口地址
                data,//请求参数
            }).then((res) => {
                if (res.status == 200) {
                    if (res.data.code === 200) {
                        resolve(res.data);
                    }else {
                        Message.error(res.data.msg);
                    }
                } else {
                    Message.error('系统错误，请联系管理员');
                    console.log("失败");
                    // reject(res);
                }
            });
        });
    },
};
